'use client';

import { useState, useEffect } from 'react';
import Image from 'next/image';

export default function Loading() {
  const [isVisible, setIsVisible] = useState(true);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Start exit transition after 1.2s
    const exitTimer = setTimeout(() => setIsExiting(true), 1200);
    // Remove from DOM after fade completes (1200ms + 300ms transition = 1500ms)
    const removeTimer = setTimeout(() => setIsVisible(false), 1500);

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(removeTimer);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div
      role="status"
      aria-label="Loading"
      className={`fixed inset-0 z-50 flex items-center justify-center bg-white transition-opacity duration-300 ${
        isExiting ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      <div className="flex flex-col items-center gap-3 animate-pulse">
        <Image width={56} height={56} src="/images/logo.webp" alt="MPay logo" />
      </div>
    </div>
  );
}